/** Created by azhou on 2019/3/22.*/
<template>
  <div>
    <public-title>系统收款</public-title>
    <div class="bg-white load-area">
      <div class="d-center-between flex-wrap">
        <left-text-border class="w-45 mb-3" leftText="订单ID" v-model="searchData.oid" @enter="confirmSearch"/>
        <left-text-select class="w-45 mb-3" leftText="支付类型" :options="$GVAR.payChannel" v-model="searchData.channel_type"/>
        <left-text-border class="w-45 mb-3" leftText="交易ID" v-model="searchData.tid" @enter="confirmSearch"/>
        <left-text-select class="w-45 mb-3" leftText="交易状态" :options="$GVAR.payTypeStatus " v-model="searchData.status"/>
        <left-text-border class="w-45 mb-3" leftText="渠道交易号" v-model="searchData.channel_trade_no" @enter="confirmSearch"/>
        <div class="w-45 mb-3 d-center-start" >
          <el-select v-model="timeType" placeholder="时间查询" size="small" class="mr-1" style="width: 260px;">
            <el-option v-for="item in timeChoose" :key="item.value" :label="item.name" :value="item.value" />
          </el-select>
          <el-date-picker v-model="timestamp" type="daterange" class="w-100" size="small"
                  v-show="$GFUN.isInArray(['timeFrame','postTime','dealTime'],timeType)"
                  range-separator="至" value-format="timestamp" start-placeholder="开始时间"
                  end-placeholder="结束时间" />
          <el-date-picker type="date" v-model="timetime" class="w-100" size="small" 
                          v-show="timeType === 'timeArr'" placeholder="可选择一个日期" />
        </div>
      </div>
      <div class="d-center-between mb-3">
          <div class="text-left ml-2 text-blue totals">
              <p>统计:</p>
              <p>总费用：{{AdminDataLists.info.total.total_fee_total /100 | formatMoney}} 元</p>
              <p>实际支付费用：{{AdminDataLists.info.total.payer_total_fee_total /100 | formatMoney}} 元</p>
              <p>实际退款费用：{{Math.abs(AdminDataLists.info.total.refund_fee_total) /100 | formatMoney}} 元</p>
          </div>
          <el-button type="success" size="small" @click="loadTable" class="loadTable">下载表单</el-button>
          <el-button type="primary" size="small" @click="confirmSearch">搜索</el-button>
        </div>
      <p v-if="AdminDataLists.total<=0" class="mt-3">当前没有数据</p>
      <div v-else class="el-tables payment">
        <template>
          <el-table
            :data="AdminDataLists.lists"
            :summary-method="getSummaries"
             show-summary
            :cell-style="{whiteSpace: 'pre-wrap'}"
            border
            stripe
            max-height="780"
            style="width: 100%">
            <!--表单内容-->
            <el-table-column v-for="(item,index) in fundsForm" :key="index" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" header-align="center">
              <!-- 自定义表头 -->
              <template slot="header" slot-scope="scope">
                <span>{{ scope.column.label }}</span>
                <!-- <p v-if="item.total">{{ AdminDataLists.info.total[item.total] /100 | formatMoney}}</p> -->
              </template>
              <template slot-scope="scope">
                <!--订单号-->
                <div class="cursor-pointer pointers" :class="{'text-center':item.center}" v-if="item.pattern==='oid'" @click="goHotelDetail(scope.row)">{{ scope.row[item.prop]}}</div>
                <!--时间-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='time'">{{ scope.row[item.prop]| formatTimestamp(1)}}</div>
                <!--金额-->
                <div :class="{'text-center':item.center}" v-else-if="item.pattern==='money'">
                  {{ scope.row[item.prop]/100 | formatMoney}}
                  <div  class="refund_fee" v-if="scope.row.refund_fee<0" @click="record=true;oid=scope.row.tid">(-{{Math.abs(scope.row.refund_fee)/100 | formatMoney}})</div>
                </div>
                <!--状态-->
                <div :class="{'text-center':item.center}" v-else-if="item.pattern==='status'">{{ scope.row[item.prop]| formatVar('payTypeStatus')}}</div>
                <!--支付类型-->  
                <div :class="{'text-center':item.center}" v-else-if="item.pattern==='type'">{{ scope.row[item.prop]| formatVar('payChannel')}}</div>
                <!--其他-->
                <div :class="{'text-center':item.center}" v-else>{{ scope.row[item.prop]}}</div>
              </template>
            </el-table-column>
              <!--操作按钮-->
              <el-table-column
                fixed="right"
                header-align="center"
                label="操作"
                width="100">
                <template slot-scope="scope">
                  <el-button v-if="Math.abs(scope.row.refund_fee)!=scope.row.total_fee" @click="checkDetail(scope.row)" type="text" size="small" style="margin: 0 auto; display: block;">退款</el-button>
                  <span class="refund" v-else >已退全额</span>
                </template>
              </el-table-column>
          </el-table>
          <el-pagination background layout="prev, pager, next, sizes" class="mt-4" :page-sizes="[10,15,20,30]" :page-size="Formdata.num" @size-change="handleSizeChange"
                       :total="AdminDataLists.total" :current-page="Number(Formdata.page)" @current-change="handleCurrentChange"/>
        </template>
      </div>
    </div>
    <!--交易退款弹窗-->
    <el-dialog title="交易退款" :visible.sync="showDetail" width="500px"  center  top="32vh" class="may">
      <PaymentRefund  :OrderDetail="OrderDetail" @close="showDetail=false" v-if="showDetail" @countdownPromise="countdownPromise" ></PaymentRefund>
    </el-dialog>
     <!--支明细弹窗-->
    <el-dialog :visible.sync="record" width="560px" center id="record" class="custom-dialog " top="32vh">
      <Refund :oid="oid" v-if="record"></Refund>
    </el-dialog>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState } from 'vuex'
  import Refund from './Refund.vue';
  import PaymentRefund from '../../payment/Refund.vue';
  export default {
    name: 'IncomeList',
    computed: {
      ...mapState(['AdminDataLists','newMessageInform']),
      ...mapGetters(['storeInfo','adminInfo']),
      queryCon() { return this.$route.query },
      //搜索条件-开始时间
      startTime() { return this.timestamp ? this.timestamp[0] / 1000 : ''; },
      //搜索条件-结束时间
      endTime() { return this.timestamp ? this.timestamp[1] / 1000 + 86399 : ''; },
      titleArr() {
        let arr = ['交易ID','渠道类型','渠道交易号','订单ID','总费用(元)','实际支付费用(元)','费用类型','用户支付费用类型','交易类型','交易状态','支付时间'];
        if (!this.is_merge) arr = arr.concat(['操作']);
        return arr;
      },
      timeChoose() {
        let arr =  [
          {name:`按时间段`,value:'timeFrame'},
          {name:`按日期`,value:'timeArr'},
        ];
        return arr
      },
    },
    components: {Refund,PaymentRefund},
    watch:{
      //接收到消息提前刷新页面
      newMessageInform (newVal) {
          if(newVal.type==101){
            this.getDataLists(); 
          }
          if(newVal.type==102){
              this.countdown=false;
              console.log( this.countdown,'77')
              this._alert('退款申请成功',() => {})
              this.getDataLists();
          }
      }
    },
    created() { 
      // 读取本地缓存
      const cache = JSON.parse(localStorage.getItem('incomeCache') || '{}');
      // 有缓存就回填表单
       if (this.$route.query) this.Formdata.page = Number(this.$route.query.page||1);
      if (cache.num) this.Formdata.num = Number(cache.num);
      this.getDataLists(); 
    },
    data() {
      return {
        fundsForm:[ 
          {name:'交易ID',prop:'tid',center:true,width:180},
          {name:'渠道类型',prop:'channel_type',width:150,center:true,pattern:'type'},
          {name:'渠道交易号',prop:'channel_trade_no', minWidth:200,center:true},
          {name:'订单ID',prop:'oid',width:150,center:true,pattern:'oid'},
          {name:'总费用(元)',prop:'total_fee',center:true,minWidth:150,pattern:'money'},
          {name:'实际支付费用(元)',prop:'payer_total_fee',center:true,minWidth:150,pattern:'money'},
          {name:'费用类型',prop:'fee_type',center:true,width:150},
          {name:'用户支付费用类型',prop:'payer_fee_type',center:true,width:150},
          {name:'交易类型',prop:'trade_type',center:true,width:150},
          {name:'交易状态',prop:'status',center:true,width:150,pattern:'status'},
          {name:'支付时间',prop:'add_time',center:true,width:200  ,pattern:'time'},
        ],
        record:false,
        OrderDetail:'',
        oid:'',
        timeType:'timeFrame',
        timestamp: [],
        timetime:'',
        showDetail:false,
        currentItem:{},     
        out_trade_no:'',
        is_merge:false,
        Formdata:{
            num:10,                              //每页显示条数
            page:1,                              //当前页

        },
        searchData:{
            oid:'',                              //订单ID
            tid:'',                              //交易ID
            channel_type:'0',                    //渠道类型
            channel_trade_no:'',                 //渠道交易号
            status:'',                           //交易状态
        },
        loading:'666777',
        countdown:true,                           //是否执行
      }
    },
    methods:{
      ...mapActions(['getAdminDataLists','adminSetInvoice','POST_Admin_DownloadForm']),
      //确认搜索
        confirmSearch(){
          this.Formdata.page=1;
          this.getDataLists();
      },
      //订单详情页
      goHotelDetail (e) {
          let cardItem=e;
          let routeUrl = this.$router.resolve({
              name: 'OrderDetail',
              query: {
                  orderType: 3,
                  orderId: cardItem.oid,
                  storeId: this.storeInfo.type == 2 ? cardItem.main_id : (cardItem.store_id || cardItem.appoint),
                  status: cardItem.status,
              }
          });
          window.open(routeUrl.href, '_blank');
      },
      //设置分页数量
      handleSizeChange(val) {
        this.Formdata.num = val;
        this.updateQuery({ num: val })
        this.getDataLists();
      },
      //设置当前页
      handleCurrentChange(val) {
        // 把参数存进路由地址栏，页面不动
        this.Formdata.page = val;
        this.updateQuery({ page: val });
        this.getDataLists();
      },
      // 统一更新路由方法
      updateQuery(query) {
        this.$router.replace({
          query: { ...this.$route.query, ...query }
        });
        // 2. 存入本地存储
        let cache = JSON.parse(localStorage.getItem('incomeCache') || '{}')
        localStorage.setItem('incomeCache', JSON.stringify({ ...cache, ...query }))
      },
      //底部合计
      getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
              if (index === 0) {
                sums[index] = '小计';
                return;
              }
              const excludeFields = ['add_time', 'status', 'store_type', 'handle_time', 'oid', 'add_time','bank_card','channel_type','channel_trade_no'];
              const values = data.map(item => Number(item[column.property])); 
              const totalRefund = Math.abs(data.reduce((sum, item) => sum + (Number(item.refund_fee) || 0), 0));
              console.log(totalRefund);
              if (!values.every(isNaN) && !excludeFields.includes(column.property)) {
                sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);
                sums[index] = column.property != 'total_fee'? `${(sums[index]/100).toFixed(2)}` : `总：${(sums[index]/100).toFixed(2)} \n 退：${(totalRefund/100).toFixed(2)} \n 实：${(sums[index]/100-totalRefund/100).toFixed(2)}`;
              } else {
                sums[index] = '';
              }
            });
            return sums;
      },
      //点击退款
      checkDetail(item) {
        this.showDetail=true;
        this.OrderDetail = item;
      },
      //订单详情页
      goHotelDetail (e) {
            let cardItem=e;
            let routeUrl = this.$router.resolve({
                name: 'OrderDetail',
                query: {
                    orderType: 3,
                    orderId: cardItem.oid,
                    storeId: this.storeInfo.type == 2 ? cardItem.main_id : (cardItem.store_id || cardItem.appoint),
                    status: cardItem.status,
                }
            });
            window.open(routeUrl.href, '_blank');
      },
      countdownPromise(res) {
          this.loading=res.loading;
          this.countdown=true;
          setTimeout(() => {
            if(this.countdown){
                this.getDataLists();
                this._alert('退款申请已处理,请耐心等待',() => {})
            } 
          },20000);
      },
      //获取搜索表单
      getSearchForm() {
        let data={
          ...this.Formdata,
          ...this.searchData
        };
        let start = this.timestamp && this.timestamp.length > 0 ? this.timestamp[0] / 1000 : '';
        let end = this.timestamp && this.timestamp.length > 0 ? this.timestamp[1] / 1000 + 86399 : '';
        switch (this.timeType) {
          case 'timeArr':
           let timeArr = this.timetime?this.timetime.getTime() / 1000:'';
            data.add_time = timeArr;
            break;
          case 'timeFrame':
            data.add_time = start?start+','+end:'';
            break;
        }
        return data;
      },
      //获取交易记录列表
      getDataLists() {
        this.getAdminDataLists({
          type:'income',
          data:this.getSearchForm(),
        });
      },
      //待付款下载表单
      loadTable(){
        this.POST_Admin_DownloadForm({data:this.getSearchForm(),type:3})
      },
    }
  }
</script>
<style lang="css" scoped>
  .pointers:hover{
    color: var(--smtc-color-primary); 
  }
  .refund_fee{
    font-size: 13px;
    margin-top: 2px;
    color:brown;
    cursor: pointer;
  }
  .goHotelDetail{
    cursor: pointer;

  }
 .goHotelDetail:hover{
    color: var(--smtc-color-primary); 
  }
  .loadTable{
    margin-left: auto;
  }
</style>
<style>
  .payment .el-table__footer-wrapper tr td:nth-child(5) .cell{
    text-align: left !important;
    width: 90% !important;
    margin: 0 auto;
  }
  /* 让合计行支持 \n 换行 */
  .payment .el-table__footer-wrapper tr td .cell {
    white-space: pre-line !important;
    
  }
  .custom-dialog .el-dialog__header {
    padding: 0; /* 如果需要 */
  }
  .custom-dialog .el-dialog__body {
    padding: 0; /* 根据需要调整 */
    
  }
    
  .custom-dialog .el-dialog__headerbtn .el-dialog__close,.text-dialog .el-dialog__headerbtn .el-dialog__close{
    color: #999;
  }
  .custom-dialog .el-dialog__headerbtn{
    top: 14px;
    right:14px;
    font-size: 20px;
    z-index: 99;
  }
  .custom-dialog  .el-dialog__headerbtn .el-dialog__close,.text-dialog .el-dialog__headerbtn .el-dialog__close{
  color: #fff;
  font-size: 20px;
  }
  .custom-dialog  .el-dialog__headerbtn{
    top: 15px;
    right: 15px;
  }
  .may .el-dialog__headerbtn .el-dialog__close{
    font-size: 18px;
    color: #999;
  }
  .refund{
    margin: 0 auto;
    display: block;
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: #666;
  }
  .totals{
    display: flex;
  } 
  .totals p{
    border-left: 1px #eee solid;
    padding: 0 10px;
    color: #666;
  }
  .totals p:nth-child(1),
  .totals p:nth-child(2) {
    border-left: none;
    padding-left: 0;
  }
</style>